import React from "react";
import Layout from '../components/layout';

import Header from '../components/header';
import Welcome from '../components/welcome';
import About from '../components/about';
import Resumes from '../components/resumes';
import Portafolios from '../components/portafolios';
import Contact from '../components/contact';
import Posts from '../components/posts';

const IndexPage = () => (
  <Layout>
    <div className="wrapper">
      <Header />
      <Welcome />
      <About />
      <Resumes />
      <Portafolios />
      <Posts />
      <Contact />
    </div>
  </Layout>  
)

export default IndexPage
